import { ZodType } from 'zod';

export const isOfType = <T>(obj: unknown, schema: ZodType<T>): obj is T => {
  return schema.safeParse(obj).success;
};
